import {GridItem} from '@chakra-ui/react';
import {keyBy} from 'lodash';
import React, {memo, useEffect} from 'react';
import {AiOutlineClose} from 'react-icons/ai';
import {FaArrowRight} from 'react-icons/fa';
import {useDispatch, useSelector} from 'react-redux';
import {useRequestState, useS3Service} from '~/hooks';
import {getSignedUrlS3} from '~/redux/apps/thunk';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {ModalProps} from '~/types/general';
import {
  AppModal,
  Col,
  Row,
  UiBox,
  UiButton,
  UiCenter,
  UiCheckbox,
  UiGrid,
  UiIcon,
  UiImage,
  UiInput,
  UiSimpleGrid,
  UiSpinner,
  UiText,
  UiTextarea,
} from '../elements';

interface Props {
  isShowing: boolean;
  onDismissModal: () => void;
  imgUrl: string;
  isCentered?: boolean;
}

const ViewImageModal = ({isShowing, onDismissModal, imgUrl, isCentered = false}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const {getSignedUrl} = useS3Service();
  const [imageURL, setImageURL] = React.useState<string>(imgUrl);
  const {loading} = useRequestState(getSignedUrlS3);
  const onCloseModal = () => {
    onDismissModal();
  };

  const onClickSubmit = async (e: React.FormEvent) => {
    onCloseModal();
  };

  useEffect(() => {
    async function fetchData() {
      const url = await getSignedUrl(imgUrl);
      setImageURL(url);
    }
    if (isShowing) {
      fetchData();
    }
  }, [getSignedUrl, imgUrl, isShowing]);

  const renderContent = () => {
    if (loading) {
      return (
        <UiCenter>
          <UiSpinner size="lg" />;
        </UiCenter>
      );
    }
    return <UiImage loading="lazy" my={5} boxSize="100%" url={imageURL} />;
  };

  return !isShowing ? null : (
    <AppModal
      hideSubmit
      isCentered={isCentered}
      actions={null}
      isOpen={isShowing}
      onClose={onCloseModal}
      contentMinW="40%"
      closeOnEsc
      closeOnOverlayClick
    >
      {renderContent()}
    </AppModal>
  );
};

export default memo(ViewImageModal);
